import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#343434";
function ARY({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M17.938 15.832a.636.636 0 00.427-.645v.825a.68.68 0 01-.446.645l-5.691 2.05a.6.6 0 01-.447 0L6.09 16.658a.675.675 0 01-.446-.645v-.825c0 .284.176.55.446.645l5.71 2.05a.6.6 0 00.446 0zm0-1.46a.65.65 0 00.427-.646v.825a.68.68 0 01-.446.645l-5.691 2.05a.6.6 0 01-.447 0L6.09 15.197a.675.675 0 01-.446-.645v-.835c0 .294.176.55.446.654l5.71 2.05a.6.6 0 00.446 0zm0-1.47a.66.66 0 00.437-.637v.825a.68.68 0 01-.447.645l-5.691 2.05a.6.6 0 01-.446 0L6.09 13.726a.675.675 0 01-.446-.645v-.825c0 .285.176.55.446.645l5.71 2.05a.6.6 0 00.446 0zM5.625 7.995a.675.675 0 01.446-.645l5.701-2.058a.6.6 0 01.446 0L17.92 7.35a.675.675 0 01.446.645v3.624a.68.68 0 01-.446.645l-5.71 2.05a.6.6 0 01-.446 0l-5.692-2.05a.675.675 0 01-.446-.645z" /></Svg>;
}
ARY.DefaultColor = DefaultColor;
export default ARY;